export default __webpack_public_path__ + "static/media/model_preparation.65ee813d.png";